export const MEMBERSHIP_TIER_BENEFITS = {
  free: [
    '$3 trade completion fee',
    '6% cash exchange fee',
    'TradeProtect: $5.00 per trade (optional)',
    'No promoted matches',
  ],
  premium_basic: [
    'No trade completion fees',
    '4% cash exchange fee',
    'TradeProtect: $5.00 per trade (optional)',
    'No promoted matches',
  ],
  premium_plus: [
    'No trade completion fees',
    '4% cash exchange fee',
    'TradeProtect: $3.00 per trade (optional)',
    'Promoted matches: priority placement in match results',
    'Bump Listings: move all active listings to top once per week',
  ],
};
